import { Component, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'page-meta',
  templateUrl: './page-meta.component.html',
  styleUrls: ['./page-meta.component.scss']
})
export class PageMetaComponent implements OnChanges {
  @Input() description: string;
  @Input() keywords: string;

  constructor(private meta: Meta) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['description'] && changes['description'].currentValue !== changes['description'].previousValue) {
      const description = changes['description'].currentValue;
      this.meta.updateTag({ name: 'description', content: description }, `name='description'`);
      this.meta.updateTag({ name: 'twitter:description', content: description }, `name='twitter:description'`);
      this.meta.updateTag({ name: 'og:description', content: description }, `name='og:description'`);
    }

    if (changes && changes['keywords'] && changes['keywords'].currentValue !== changes['keywords'].previousValue) {
      const keywords = changes['keywords'].currentValue;
      this.meta.updateTag({ name: 'keywords', content: keywords }, `name='keywords'`);
    }
  }
}
